import { useTranslation } from "react-i18next";
import { MEDIA } from "../data/site";
import { Reveal } from "../components/Reveal";
import { SectionHeading } from "../components/SectionHeading";
import { usePageTitle } from "../lib/usePageTitle";

const STEPS = [
    { key: "s1", n: "01", img: MEDIA.heroSecondary },
    { key: "s2", n: "02", img: MEDIA.mfg1 },
    { key: "s3", n: "03", img: MEDIA.mfg2 },
    { key: "s4", n: "04", img: MEDIA.slab1 },
    { key: "s5", n: "05", img: MEDIA.slab2 },
];

export default function Process() {
    usePageTitle("meta.process");
    const { t } = useTranslation();

    return (
        <main data-testid="page-process" className="pt-32">
            <section className="px-6 md:px-12 lg:px-20 pt-12 pb-20">
                <Reveal>
                    <p className="text-[10px] uppercase tracking-[0.35em] text-[#C5A059]">
                        {t("process.overline")}
                    </p>
                    <h1 className="mt-6 font-heading text-5xl md:text-6xl lg:text-7xl text-[#E8E3D9] leading-[1.02] tracking-tighter max-w-5xl">
                        {t("process.h1_a")}{" "}
                        <span className="italic text-[#C5A059]">
                            {t("process.h1_b")}
                        </span>{" "}
                        {t("process.h1_c")}
                    </h1>
                </Reveal>
            </section>

            <section className="px-6 md:px-12 lg:px-20 pb-24">
                <div className="space-y-24 md:space-y-32">
                    {STEPS.map((s, i) => (
                        <Reveal key={s.n}>
                            <div
                                data-testid={`process-block-${s.n}`}
                                className={`grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center ${
                                    i % 2 === 1 ? "lg:[direction:rtl]" : ""
                                }`}
                            >
                                <div className="lg:col-span-7 [direction:ltr]">
                                    <img
                                        src={s.img}
                                        alt={t(`process.steps.${s.key}.title`)}
                                        className="w-full h-[55vh] object-cover"
                                    />
                                </div>
                                <div className="lg:col-span-5 [direction:ltr]">
                                    <p className="font-heading text-7xl text-[#C5A059] leading-none">
                                        {s.n}
                                    </p>
                                    <h2 className="mt-6 font-heading text-3xl md:text-4xl text-[#E8E3D9] tracking-tight leading-tight">
                                        {t(`process.steps.${s.key}.title`)}
                                    </h2>
                                    <p className="mt-5 text-[#A39E93] font-light leading-relaxed max-w-md">
                                        {t(`process.steps.${s.key}.copy`)}
                                    </p>
                                </div>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </section>

            <section className="px-6 md:px-12 lg:px-20 pb-24 md:pb-32">
                <Reveal>
                    <div className="bg-[#1A1A1A] border-l-2 border-[#C5A059] p-10 md:p-14">
                        <SectionHeading
                            overline={t("process.infra.overline")}
                            title={t("process.infra.title")}
                            kicker={t("process.infra.kicker")}
                        />
                    </div>
                </Reveal>
            </section>
        </main>
    );
}
